import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Class names of a component: conditional ones with clsx, conflicting Tailwind utilities resolved by the last one. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
